import { render, staticRenderFns } from "./CMSCustomFieldShow.vue?vue&type=template&id=cc99c6e8&"
import script from "./CMSCustomFieldShow.vue?vue&type=script&lang=js&"
export * from "./CMSCustomFieldShow.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports